import { Pipe, PipeTransform } from '@angular/core';
import { ConstantsStatusType } from '../constants/constants.interface';
import { ConstantsService } from '../constants/constants.service';

/**
 * Convert status notation.
 */
@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {

  /** Status constants. */
  statuses: ConstantsStatusType[];

  constructor(
    private constantsService: ConstantsService
  ) { }

  /**
   * Convert status notation.
   *
   * Example:
   *  - Convert id to displayName;
   *  - Convert id to color.
   *
   * @note Because of how the legacy ui-router works, Constants may not always
   *  be available in the constructor. When migrated, move the status setter.
   *
   * @param value The element's status.
   * @param i Input type as key.
   * @param [o=displayName] Output type as key.
   * @param [def] Optional default value.
   * @returns Converted status.
   */
  transform<Key extends keyof ConstantsStatusType>(
    value: ConstantsStatusType[Key], i: Key, o: keyof ConstantsStatusType = 'displayName', def?: any
  ): ConstantsStatusType[keyof ConstantsStatusType] {
    const input = i || '_id';
    this.statuses = this.statuses || this.constantsService.getStatusTypes();
    const status = this.statuses.find(s => s[input] === value);

    return status && status[o] || def || '';
  }
}
